import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

const StatusChart = ({ data }) => {
    return (
        <div className="calc-setting-table">
        <table className="table">
            <colgroup>
            <col />
            </colgroup>
            <thead>
                <tr>
                    <th colSpan="3" className="text-left"><span className="calc-setting-table-header">Chart skipting</span></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="text-center">Chart</td>
                </tr>
            </tbody>
        </table>
        </div>
    );
  
}

StatusChart.propTypes = {
  data: PropTypes.any,
};

export default StatusChart;
